import { render, staticRenderFns } from "./PermissionGroupList.vue?vue&type=template&id=27b346af&scoped=true&"
import script from "./PermissionGroupList.vue?vue&type=script&lang=js&"
export * from "./PermissionGroupList.vue?vue&type=script&lang=js&"
import style0 from "./PermissionGroupList.vue?vue&type=style&index=0&id=27b346af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b346af",
  null
  
)

export default component.exports